import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AppComponent } from "app/components/app/app.component";
import { WrittenFilmReviewPage } from "app/components/writtenFilmReviewPage/writtenFilmReviewPage.component";
import { IndexComponent } from "app/components/index/index.component";
import { ListReviewsPage } from "app/components/listFilmReviewsPage/listFilmReviewsPage.component";
import { VideoFilmReviewPage } from "app/components/videoFilmReviewPage/videoFilmReviewPage.component";
import { CriticalEssayPage } from "app/components/criticalEssayPage/criticalEssayPage.component";
import { VideoPage } from "app/components/videoPage/videoPage.component";
import { TheoreticalEssayPage } from "app/components/theoreticalEssayPage/theoreticalEssayPage.component";
import { NewsPage } from "app/components/newsPage/newsPage.component";
import { ListScholarlyArticlesPage } from "app/components/listScholarlyArticlesPage/listScholarlyArticlesPage.component";
import { ListNewsPage } from "app/components/listNewsPage/listNewsPage.component";
import { ListVideosPage } from "app/components/listVideosPage/listVideosPage.component";
import { AboutPage } from "app/components/aboutPage/aboutPage.component";
import { MobileSideMenu } from "app/components/mobileSideMenu/mobileSideMenu.component";
import { LoginPage } from "app/components/loginPage/loginPage.component";
import { AdminConsolePage } from "app/components/adminConsolePage/adminConsolePage.component";
import { AddContentPage } from "app/components/adminAddContentPage/adminAddContentPage.component";

const routes: Routes = [
    {
        path: 'index',
        component: IndexComponent
    },
    {
        path: '',
        redirectTo: '/index',
        pathMatch: 'full'
    },
    {
        path: 'review-list',
        component: ListReviewsPage
    },
    {
        path: 'written-film-review/:id',
        component: WrittenFilmReviewPage
    },
    {
        path: 'video-film-review/:id',
        component: VideoFilmReviewPage
    },
    {
        path: "critical-essay/:id",
        component: CriticalEssayPage
    },
    {
        path: "video/:id",
        component: VideoPage
    },
    {
        path: "theoretical-essay/:id",
        component: TheoreticalEssayPage
    },
    {
        path: "content-news/:id",
        component: NewsPage
    },
    {
        path: "scholarly-articles-list",
        component: ListScholarlyArticlesPage
    },
    {
        path: "content-news-list",
        component: ListNewsPage
    },
    {
        path: "videos-list",
        component: ListVideosPage
    },
    {
        path: "login",
        component: LoginPage
    },
    {
        path: "admin-console",
        component: AdminConsolePage
    },
    {
        path: "about",
        component: AboutPage
    },
    {
        path: "admin-console/content/add",
        component: AddContentPage
    },
]

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule{}


// WEBPACK FOOTER //
// /home/ppeters/filmCritClient/src/app/app-routing.module.ts